import { FaTimes } from "react-icons/fa";

const AttributeModal = ({ isOpen, onClose, attributes, formatCurrency }) => {
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-lg w-full max-h-[80vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-secondary">Product Attributes</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700"><FaTimes size={20} /></button>
          </div>
          <div className="divide-y">
            {attributes.map((attr, index) => (
              <div key={index} className="py-3">
                {attr.attributeId && (
                  <>
                    <div className="flex justify-between">
                      <p className="font-medium">{attr.attributeId.name || 'Attribute'}:</p>
                      <p>{attr.attributeId.value || 'N/A'}</p>
                    </div>
                    {attr.price && Number(attr.price) !== 0 && (
                      <p className="text-sm text-gray-600">Price Adjustment: {Number(attr.price)}</p>
                    )}
                    {attr.isImage && attr.image && (
                      <div className="mt-2"><img src={attr.image} alt="Attribute" className="w-24 h-24 object-cover rounded-md" /></div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  export default AttributeModal